import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای لیست انبارها

در این بخش می‌توانید انبارها و مکان‌های فیزیکی ذخیره‌سازی را تعریف و مدیریت کنید.

## ۱. لیست انبارها
تمامی انبارهای موجود سازمان در این بخش قابل مشاهده هستند.

## ۲. ویرایش و تعریف
شما می‌توانید انبارهای جدید اضافه کرده و یا تنظیمات انبارهای موجود (مانند کد انبار و وضعیت فعال بودن) را ویرایش کنید.

export default Layout;
